<div class="custom-snackbar-wrapper" fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="6px">
    <div fxLayout="row" fxLayoutAlign="start center">
        <div class="snackbar-icon-wrapper fa-beat-two" fxLayout="row" fxLayoutAlign="center center">
            <mat-icon class="snackbar-icon">
                {{icon}}
            </mat-icon>
        </div>
        <div class="snackbar-content-wrapper">
            <div fxLayout="row wrap" fxLayoutAlign="space-between center">
                <div class="snackbar-title">{{title}}</div>
                <div class="snackbar-navigate" *ngIf="data?.type === 'DOWNLOAD'" (click)="navigateToDashboard()">Go To
                    My Downloads
                    <mat-icon class="click-icon">open_in_new</mat-icon>
                </div>
                <div *ngIf="data?.type !== 'DOWNLOAD'"></div>
            </div>
            <div class="snackbar-content">{{data?.message}}</div>
        </div>
    </div>
    <button mat-button class="toolbar-icon-button" (click)="closeSnackbar()">
        <mat-icon class="material-icons">close</mat-icon>
    </button>
</div>
